module.exports = __webpack_public_path__ + "img/banner.d7d5625e.jpg";